import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const PAGE_TITLE = 'Page not found | GetSocs';

export default function NotFound() {
  useEffect(() => {
    const previousTitle = document.title;
    const existingRobotsMeta = document.head.querySelector('meta[name="robots"]');
    const previousRobotsContent = existingRobotsMeta?.getAttribute('content');
    const robotsMeta = existingRobotsMeta || document.createElement('meta');

    document.title = PAGE_TITLE;
    robotsMeta.setAttribute('name', 'robots');
    robotsMeta.setAttribute('content', 'noindex, nofollow');
    if (!existingRobotsMeta) document.head.appendChild(robotsMeta);

    return () => {
      document.title = previousTitle;
      if (existingRobotsMeta) {
        if (previousRobotsContent === null) {
          existingRobotsMeta.removeAttribute('content');
        } else {
          existingRobotsMeta.setAttribute('content', previousRobotsContent);
        }
      } else {
        robotsMeta.remove();
      }
    };
  }, []);

  return (
    <section className="not-found-page" aria-labelledby="not-found-title">
      <div className="not-found-card">
        <p className="not-found-code" aria-hidden="true">404</p>
        <p className="not-found-eyebrow">Page not found</p>
        <h1 id="not-found-title">We can't find that page</h1>
        <p className="not-found-message">
          The link may be outdated, or the page may have moved. You can head back to the
          marketplace and keep exploring.
        </p>
        <div className="not-found-actions">
          <Link className="not-found-link not-found-link-primary" to="/">
            Back to home
          </Link>
          <Link className="not-found-link not-found-link-secondary" to="/products">
            Browse products
          </Link>
        </div>
      </div>
    </section>
  );
}
